import { Link } from "react-router-dom";
import Icon from "../image/Icon";
import {
  icBooking,
  icBookingActive,
  icCity,
  icCityActive,
  icHome,
  icHomeActive,
  icMore,
  icMoreActive,
  icPass,
  icPassActive,
} from "../image/image-src";
import { useResponsive } from "../../hooks/useResponsive";
import clsx from "clsx";

export type TNav = "HOME" | "CITY" | "PASS" | "BOOKING" | "MORE";

export const BotNav = ({ active }: { active: TNav }) => {
  const responsive = useResponsive();
  if (responsive.isDesktop) return null;
  return (
    <div className="bot-nav z-[200] bg-white">
      <div className="grid-template-rows-1 grid grid-cols-5">
        <NavBtn nav="HOME" active={active} />
        <NavBtn nav="CITY" active={active} />
        <NavBtn nav="PASS" active={active} />
        <NavBtn nav="BOOKING" active={active} />
        <NavBtn nav="MORE" active={active} />
      </div>
    </div>
  );
};

const getIcon = (k: TNav) => {
  switch (k) {
    case "HOME":
      return [icHome, icHomeActive, "Home", "/"];
    case "CITY":
      return [icCity, icCityActive, "City", "/cities"];
    case "PASS":
      return [icPass, icPassActive, "Pass", "/pass"];
    case "BOOKING":
      return [icBooking, icBookingActive, "Booking", "/mypage/booking"];
    case "MORE":
      return [icMore, icMoreActive, "More", "/more"];
  }
};

export const NavBtn = ({
  nav,
  active,
  sub,
}: {
  nav: TNav;
  active: TNav;
  sub?: string;
}) => {
  const [src, srcActive, txt, href] = getIcon(nav);
  return (
    <Link to={href as string}>
      <span className="flex h-[4rem] flex-col items-center justify-center gap-1">
        <span className="relative">
          <Icon src={active === nav ? srcActive : src} className="size-7" />
          {sub && <span className="tt-sub">{sub}</span>}
        </span>
        <span
          className={clsx(
            "text-center text-[11px] font-medium leading-[13px]",
            active === nav ? "font-semibold text-[#007aff]" : "text-[#BFC5C9]",
          )}
        >
          {txt}
        </span>
      </span>
    </Link>
  );
};
